import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../../store/authSlice";
import "./TwoFA.css";
import api from "../../../axiosconfig.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { useOnboarding } from "../contexts/OnboardingContext";

export const TwoFA = () => {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("DEFAULT");
  const [error, setError] = useState("");
  // const [isFormValid] = useState(false); 
  const [errorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { onboardingData, setOnboardingData } = useOnboarding();

  useEffect(() => {
    setEmail(onboardingData?.email || "DEFAULT");
  }, [onboardingData]);

  const handleCodeChange = (e) => setCode(e.target.value);

  const checkCode = async () => {
    setError("");
    setIsLoading(true);

    try {
      // Verify code
      const response = await api.post("/login", {
        request: "checktwoFA",
        email,
        code,
      });

      if (!response.data.result) {
        setError(response.data.message || "Invalid Code");
        setIsLoading(false);
        return;
      }

      // Get tokens now that code is verified
      const responseKey = await api.post("/login", {
        request: "beginLoginSession",
        email,
        code,
      });

      if (responseKey.data.result !== 0) {
        const { access_token, refresh_token, registered } = responseKey.data;

        dispatch(
          loginSuccess({
            access_token,
            refresh_token,
            user: { email }, 
          })
        );

        const { data: imgData } = await api.post("/profile", {
          request: "getProfilePictureLocation",
        });
        const profileImageLocation = imgData?.profilePictureLocation || null;
        if (profileImageLocation)
          localStorage.setItem("profileImageLocation", profileImageLocation);

        if (registered) {
          setOnboardingData((prev) => ({ ...prev, email }));
          navigate("/Onboarding");
        } else {
          navigate("/home");
        }
      }
    } catch (err) {
      console.error("Error logging in:", err);
      if (err.response) {
        setError(err.response.data?.message || "Invalid Code");
      } else {
        setError("Server error. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-code-page-wrapper">
      <div className="login-code-content-wrapper">
        <div className="login-code-content">
          <div
            className="login-code-back-dashboard"
            onClick={() => navigate(-1)}
          >
            <div className="login-code-back-icon">{"<"}</div>
            <p className="login-code-back-text">Back</p>
          </div>

          <div className="login-code-tagline-container">
            <div className="login-code-company-logo-container">
                           <svg className="logo" width="56" height="49" viewBox="0 0 56 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M28.1326 9.25302L31.7566 14.669L31.9724 15.004C34.061 18.3863 34.1512 22.6752 32.2068 26.1417L32.0056 26.4854L29.9285 29.8878V29.8888C29.8904 29.9508 29.848 30.0075 29.8025 30.0597L29.6375 30.2491L29.5496 30.0147L28.8826 28.253C28.667 27.6827 28.7255 27.0447 29.0437 26.5235L29.8601 25.1856L30.0154 24.92C31.5175 22.2423 31.4484 18.9278 29.8347 16.3145L29.6687 16.0558L27.989 13.5479L25.7957 16.7686C24.1351 19.2044 23.8543 22.2673 25.0437 24.964L27.6316 30.8263L27.6726 30.92L27.6707 30.921C28.9455 33.8744 29.0206 37.1281 27.8865 40.129L27.7722 40.422C26.5465 43.4366 24.2404 45.7945 21.2595 47.0899L20.9685 47.212C19.4209 47.8394 17.7837 48.1494 16.1521 48.1495C13.9162 48.1495 11.6914 47.5684 9.71948 46.4268L9.32788 46.1915L1.34253 41.1778L1.11011 41.0313L1.35913 40.9151L9.35229 37.1632L9.71069 37.0011C13.4366 35.39 17.7188 35.6344 21.2429 37.6808L25.2205 39.9893C25.2993 39.8228 25.3763 39.6551 25.446 39.4825V39.4815L25.6228 39.0138C26.3914 36.8186 26.3568 34.4686 25.5242 32.297L25.3337 31.8351L22.7468 25.9718C21.2056 22.4825 21.5698 18.516 23.7195 15.3624L27.8835 9.25107L28.0085 9.06845L28.1326 9.25302ZM19.9802 39.8419C17.1481 38.1972 13.7068 38.0003 10.7107 39.296L10.4226 39.4259L6.3269 41.3487L10.6658 44.0743L10.9304 44.2345C13.6818 45.8471 17.0562 46.0972 20.0222 44.8936L20.0496 44.8829C21.5598 44.2658 22.8592 43.312 23.8728 42.1017L19.9802 39.8419Z" fill="#094B38" stroke="#094B38" stroke-width="0.3"/>
                  <path d="M35.0972 37.4904C38.6395 35.5765 42.8826 35.4352 46.5493 37.1193L46.5532 37.1164L46.6489 37.1613L54.6411 40.9142L54.8892 41.0314L54.6567 41.1769L46.6724 46.1906C46.1757 46.5024 45.6557 46.7815 45.1206 47.0226L44.5806 47.2512C43.1253 47.8277 41.536 48.1193 39.8569 48.1193H25.4292C25.2772 48.1193 25.1314 48.0924 24.9956 48.0422L24.729 47.9435L24.9604 47.7795C25.5061 47.391 26.022 46.9666 26.5063 46.509L26.7437 46.3058C27.3155 45.8614 28.0226 45.6174 28.7534 45.6174H39.8569C41.2201 45.6173 42.4959 45.3831 43.6519 44.926L44.0864 44.7424C44.517 44.5484 44.935 44.3246 45.3335 44.0744L49.6733 41.3488L45.5786 39.426C42.5174 37.9892 38.9444 38.1452 36.021 39.843L36.02 39.842L28.9897 43.9592L28.7876 43.7492C29.2706 42.9924 29.6885 42.1855 30.0356 41.3342L30.0366 41.3312L30.0396 41.3234L30.1655 41.048C30.4831 40.42 30.9763 39.894 31.5884 39.5353L34.7534 37.6828L35.0972 37.4904Z" fill="#094B38" stroke="#094B38" stroke-width="0.3"/>
                  <path d="M22.0286 6.1965C22.0285 7.0587 21.7361 7.8926 21.2004 8.56564L21.0901 8.69748L19.5735 10.4348C15.1105 15.5517 14.2599 22.9239 17.2922 28.8869L17.4524 29.2268C17.8024 30.0276 17.9855 30.892 17.9856 31.7688V34.6057L17.7288 34.3488L17.718 34.3371L17.7092 34.3235L16.01 31.6848C13.7496 28.1753 12.7146 24.121 13.0178 19.9612L13.05 19.5725C13.4235 15.5624 15.0189 11.8415 17.6799 8.79221L21.7659 4.11057L22.0286 3.80881V6.1965Z" fill="#094B38" stroke="#094B38" stroke-width="0.3"/>
                  <path d="M34.0864 4.1113L38.1714 8.79294L38.4253 9.09079C41.0166 12.1822 42.5387 15.9329 42.8325 19.9619L42.8569 20.3515C43.0636 24.2448 42.0968 28.0328 40.0503 31.3545L39.8423 31.6855L38.1431 34.3242L37.8667 34.7539V31.7695C37.8667 30.7679 38.1058 29.7811 38.5601 28.8877L38.8335 28.3252C41.5321 22.4743 40.6042 15.4121 36.2954 10.456L36.2778 10.4355L34.7612 8.69821C34.1564 8.00379 33.8228 7.11607 33.8228 6.19724V3.80954L34.0864 4.1113Z" fill="#094B38" stroke="#094B38" stroke-width="0.3"/>
                  <path d="M28 1.00006C29.4093 1.00026 30.5428 2.13557 30.543 3.52545C30.543 4.91548 29.4094 6.05162 28 6.05182C26.5904 6.05182 25.4561 4.9156 25.4561 3.52545C25.4562 2.13545 26.5906 1.00006 28 1.00006Z" stroke="#094B38" stroke-width="2"/>
                </svg>
              <div className="login-code-company-name">
                <p>mindsherpa</p>
              </div>
            </div>
            <div className="login-code-tagline">
              <p>Your space to de-stress, and support each other at work.</p>
            </div>
          </div>

          <div className="login-code-dashboard-subtitle">
            <p>Code sent to {email}</p>
          </div>

          <div className="login-code-form-containe">
            <div className="login-code-code-section">
              <div className="login-code-input-container">
                <div className="login-code-wrapper">
                  <label className="login-code-label" htmlFor="twoFACode">
                    {code ? "Enter Code" : "Code"}
                  </label>
                </div>
                <div className="login-code-input-wrapper">
                  <FontAwesomeIcon
                    icon={faLock}
                    className="login-code-input-icon"
                  />
                  <input
                    type="text"
                    id="twoFACode"
                    className="twoFA-input"
                    value={code}
                    onChange={handleCodeChange}
                    placeholder="Enter your two factor authentication code"
                  />
                </div>

                {error && <p className="error-message">{error}</p>}
                {isLoading && <p className="loading-message">Processing...</p>}

                <button
                  className={`login-code-continue-button ${
                    errorMessage ? "with-error" : ""
                  }`}
                  onClick={checkCode}
                  disabled={isLoading}
                >
                  Authenticate
                </button>
              </div>
            </div>
          </div>

          <div className="terms-wrapper">
            <p className="terms-text">
              Don't have an account?
              <a href="/get-started" className="terms-link">
                {" "}
                Sign Up
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
